import { useState, useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import { useForm, Controller } from 'react-hook-form';
import {
  Box,
  FormControl,
  MenuItem,
  Select,
  InputLabel,
} from '@material-ui/core';
import { useIntl } from 'umi';
import InputAdornment from '@material-ui/core/InputAdornment';
import ClearIconML from '@/components/ClearIconML/index';
import IconButton from '@material-ui/core/IconButton';
import ClearIcon from '@material-ui/icons/Clear';
import SearchIcon from '@material-ui/icons/Search';
import ReplayIcon from '@material-ui/icons/Replay';
import Button from '@material-ui/core/Button';
import webStorage from '@/utils/storageManager';
import SearchGroupStyled from './SearchGroupStyled';

const SearchGroup = (props) => {
  //关于国际化
  const intl = useIntl();
  const { formatMessage } = intl;
  const { query } = props;
  const { handleSearch, restClick, searchRef } = props;
  const { title, type, status, id } = query;

  const { handleSubmit, control, reset, setValue, watch } = useForm({
    defaultValues: {
      id,
      title,
      type,
      status,
    },
  });
  //单个输入框
  const [titleValue, setTitleValue] = useState();
  //置空输入框
  const handleClearType = () => {
    setValue('type', '');
    // reset('type', '');
  };
  const handleClearStatus = () => {
    setValue('status', '');
    // reset('status', '');
  };

  const watchType = watch('type');
  const watchStatus = watch('status');
  useEffect(() => {
    if (title) {
      setTitleValue(title);
    }
  }, [title]);
  const { COUPON_TYPE = [] } = webStorage.get('DICTOBJ') || {};

  const typeList = COUPON_TYPE.map((item) => ({
    value: item.dictCode,
    name: item.nameZh,
  }));
  //状态
  const statusList = [
    { name: '未开始', value: 'NOT_START' },
    { name: '进行中', value: 'UNDER_WAY' },
    { name: '已结束', value: 'COMPLETE' },
  ];

  const handleRestClick = () => {
    setTitleValue('');
    const resetSearch = {
      title: '',
      type: '',
      status: '',
    };
    reset(resetSearch);
    restClick && restClick(resetSearch);
  };
  return (
    <SearchGroupStyled>
      <form onSubmit={handleSubmit(handleSearch)}>
        <Box className="search-wrapper">
          <Box className="left">
            <Box className="first-line">
              <Controller
                render={(rp) => (
                  <TextField
                    variant="standard"
                    name="title"
                    control={control}
                    id="basic"
                    className="input"
                    label={formatMessage({ id: 'coupon.mgt.n02.lbl01' })}
                    defaultValue={''}
                    value={rp.value ?? titleValue}
                    onChange={(e) => {
                      setValue('title', e.target.value);
                      setTitleValue(e.target.value);
                      return rp.value;
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            className="clear-btn"
                            onClick={() => {
                              setTitleValue('');
                              setValue('title', '');
                            }}
                            edge="end"
                          >
                            {titleValue ? (
                              <ClearIcon className="clear-icon" />
                            ) : (
                              ''
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
                name="title"
                control={control}
                id="basic"
                className="input"
                label={formatMessage({ id: 'coupon.mgt.n02.lbl01' })}
                defaultValue={''}
              />
              <FormControl variant="standard" className="channel single-select">
                <InputLabel>
                  {formatMessage({ id: 'coupon.mgt.n02.lbl02' })}
                </InputLabel>
                <Controller
                  as={
                    <Select className="select">
                      {typeList.map((item) => (
                        <MenuItem
                          key={item.value}
                          value={item.value}
                          name={item.value}
                        >
                          {item.name}
                        </MenuItem>
                      ))}
                    </Select>
                  }
                  label="类型"
                  name="type"
                  placeholder=""
                  variant="standard"
                  defaultValue={''}
                  control={control}
                />
                {watchType && (
                  <ClearIconML
                    handleClick={handleClearType}
                    clearValue={watchType}
                  ></ClearIconML>
                )}
              </FormControl>
              <FormControl variant="standard" className="gender single-select">
                <InputLabel>
                  {formatMessage({ id: 'coupon.mgt.n02.lbl04' })}
                </InputLabel>
                <Controller
                  as={
                    <Select className="select">
                      {statusList.map((item) => (
                        <MenuItem
                          key={item.value}
                          value={item.value}
                          name={item.value}
                        >
                          {item.name}
                        </MenuItem>
                      ))}
                    </Select>
                  }
                  label={formatMessage({ id: 'coupon.mgt.n02.lbl04' })}
                  name="status"
                  variant="standard"
                  control={control}
                  defaultValue={''}
                />
                {watchStatus && (
                  <ClearIconML
                    handleClick={handleClearStatus}
                    clearValue={watchStatus}
                  ></ClearIconML>
                )}
              </FormControl>
              <div></div>
            </Box>
          </Box>
          <Box className="button-group">
            <Button
              variant="contained"
              color="secondary"
              className="reset"
              startIcon={<ReplayIcon sx={{ width: '16px', height: '16px' }} />}
              onClick={handleRestClick}
            >
              {formatMessage({ id: 'comm.action.btn.06' })}
            </Button>

            <Button
              ref={searchRef}
              variant="contained"
              type="submit"
              className="search"
              startIcon={<SearchIcon sx={{ width: '16px', height: '16px' }} />}
            >
              {formatMessage({ id: 'comm.action.btn.01' })}
            </Button>
          </Box>
        </Box>
      </form>
    </SearchGroupStyled>
  );
};
export default SearchGroup;
